import * as React from 'react';
import { RadioButton, SelectField, Text, TextInput, FormGroup, } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import { BreakdownValueWrapper, FlexWrapper, InputWrapper, InfoIcontainer, ReadonlyInputWrapper, RadioWrapper, ReadOnlyValue, RateFlexWrapper, WrapperToOverwriteLegacyCSS, ReadOnlyFormElementWrapper, } from './financeModal-stylesRethink';
import { trackDropdownChanges } from '../../../../../components/ctaButtons/tracking';
import { InfoIcon } from './InfoIcon';
import { DangerousElement } from '../../../../../components/DangerousElement';
import { dynamicStylingHelper } from '../../../../utils/AlphaHelper';
export const getFormValues = (generatedFormData) => {
    return generatedFormData.data.reduce((formTarget, form) => {
        formTarget[form.name] = form.parameter.reduce((fieldTarget, field) => {
            if (field.control.type === 'Label' && field.data[0]) {
                fieldTarget[`$${field.id}`] =
                    field.data[0].type === 'percentage' && field.data[0].text
                        ? `${field.data[0].text} ${field.displayUnit}`
                        : field.data[0].formattedValue;
            }
            else if (field.control.type === 'Edit' && field.data[0]) {
                fieldTarget[field.id] =
                    field.hasData && field.data[0] && field.data[0].text
                        ? field.control.dataType === 'decimal'
                            ? parseFloat(field.data[0].text)
                            : field.data[0].text
                        : undefined;
            }
            else if (field.control.type === 'Hidden' && field.data[0]) {
                fieldTarget[field.id] =
                    field.hasData && field.data[0] && field.data[0].text ? field.data[0].text : undefined;
            }
            else if (field.control.type === 'Select') {
                fieldTarget[field.id] = field.default;
            }
            else {
                fieldTarget[field.id] = undefined;
            }
            return fieldTarget;
        }, {});
        return formTarget;
    }, {});
};
export const renderRadioField = (field, formName, inputFields, setFormValue, calculate, loading) => {
    return (React.createElement(InputWrapper, null,
        React.createElement(FormGroup, { legend: field.label, className: "radio-wrapper" },
            React.createElement(RadioWrapper, null, field.data.map((fieldValue) => {
                return (React.createElement(React.Fragment, null, fieldValue.text && (React.createElement(WrapperToOverwriteLegacyCSS, null,
                    React.createElement(RadioButton, { id: `${field.id}_${fieldValue.value}`, name: field.id, value: fieldValue.value, disabled: loading, checked: inputFields[formName][field.id] === fieldValue.value, onChange: (evt) => {
                            setFormValue(formName, field, evt.target.value);
                            calculate();
                        }, label: `${fieldValue.text} ${field.displayUnit}`, "aria-label": useI18n({
                            id: `stockcars.financing.dynamic.overlay.arialabel.input.${field.id}`,
                            defaultMessage: `${field.id}`,
                        }) })))));
            })))));
};
export const renderSelectField = (field, formName, inputFields, setFormValue, calculate, loading, trackingService) => {
    const inputValue = getInputValue(inputFields[formName][field.id]);
    return (React.createElement(InputWrapper, null,
        React.createElement(SelectField, { id: field.id, label: field.label, disabled: loading, value: inputValue, "aria-label": useI18n({
                id: `stockcars.financing.dynamic.overlay.arialabel.input.${field.id}`,
                defaultMessage: `${field.id}`,
            }), onChange: (evt) => {
                var _a;
                setFormValue(formName, field, evt.target.value);
                calculate();
                trackDropdownChanges(trackingService, field.id, `${(_a = evt === null || evt === void 0 ? void 0 : evt.target) === null || _a === void 0 ? void 0 : _a.value} ${field === null || field === void 0 ? void 0 : field.displayUnit}`);
            }, required: true },
            React.createElement("option", { value: "", disabled: true }, field.label),
            field.data.map((fieldValue) => (React.createElement("option", { value: fieldValue.value, key: fieldValue.value },
                fieldValue.text,
                " ",
                field.displayUnit))))));
};
export const renderHiddenField = (field, formName, inputFields) => {
    return (React.createElement("input", { type: "hidden", "aria-hidden": "true", id: field.id, value: getInputValue(inputFields[formName][field.id]) }));
};
export const RenderTextField = ({ field, formName, inputFields, setFormValue, calculate, loading, shiftCurrencySymbolLeftToRight, }) => {
    const inputRef = React.useRef(null);
    const clearInputKey = useI18n({
        id: 'nemo.ui.sc.details.finance.form.button.clearInput',
        defaultMessage: 'Clear Input',
    });
    return (React.createElement(InputWrapper, null,
        React.createElement(WrapperToOverwriteLegacyCSS, null,
            shiftCurrencySymbolLeftToRight &&
                (field.id === 'DownPayment' ||
                    field.id === 'Deposit' ||
                    field.id === 'down_payment_customer_abs') && (React.createElement(Text, { tag: "p", variant: { type: 'copy', order: '2', style: 'normal' }, margin: [0, 0, '-3px', 0] }, field.label)),
            React.createElement(TextInput, { id: field.id, "aria-label": useI18n({
                    id: `stockcars.financing.dynamic.overlay.arialabel.input.${field.id}`,
                    defaultMessage: `${field.id}`,
                }), className: shiftCurrencySymbolLeftToRight &&
                    (field.id === 'DownPayment' ||
                        field.id === 'Deposit' ||
                        field.id === 'down_payment_customer_abs')
                    ? 'downPayment'
                    : '', label: shiftCurrencySymbolLeftToRight &&
                    (field.id === 'DownPayment' ||
                        field.id === 'Deposit' ||
                        field.id === 'down_payment_customer_abs')
                    ? ''
                    : field.label, disabled: loading, value: getInputValue(inputFields[formName][field.id]), inputRef: inputRef, onChange: (evt) => {
                    const decimalRegex = /^[0-9, ,, .]+$/;
                    if (field.control.dataType === 'Decimal' &&
                        (evt.target.value === '' || decimalRegex.test(evt.target.value))) {
                        setFormValue(formName, field, evt.target.value);
                    }
                    else if (field.control.dataType !== 'Decimal') {
                        setFormValue(formName, field, evt.target.value);
                    }
                }, cancelButton: shiftCurrencySymbolLeftToRight
                    ? undefined
                    : {
                        'aria-label': `${clearInputKey}`,
                        onClick: () => {
                            document.getElementById(field.id).focus();
                            inputRef.current.value = '';
                        },
                    }, onBlur: () => {
                    calculate();
                }, max: parseInt(field.control.maxInputLength, 10).toString(), extension: field.displayUnit, autoComplete: "off" }))));
};
export const renderReadonlyFieldForSummary = (summary, i18n, loading, currency) => {
    return (React.createElement(ReadOnlyFormElementWrapper, { key: `read-only-${summary.label}` },
        React.createElement(ReadonlyInputWrapper, { IsLoading: loading, key: `read-only-${summary.id}` },
            React.createElement(FlexWrapper, null,
                React.createElement(BreakdownValueWrapper, null,
                    React.createElement(Text, { variant: { type: 'copy', order: dynamicStylingHelper('2', '3'), style: 'normal' }, tag: "p", "aria-label": summary.label },
                        React.createElement(DangerousElement, { as: "span", html: summary.id === 'Rate'
                                ? `${i18n.financeRateLabelSuffix}${summary.label}`
                                : summary.label }))),
                React.createElement(BreakdownValueWrapper, null,
                    React.createElement(ReadOnlyValue, null,
                        React.createElement(Text, { variant: { type: 'copy', order: dynamicStylingHelper('2', '3'), style: 'normal' }, tag: "p", className: "read-only-value" }, getFormatedInputvalue(getInputValue(summary.data[0].value), summary, currency))),
                    (summary.help || summary.note) && (React.createElement(InfoIcontainer, null,
                        React.createElement(InfoIcon, { popupContent: summary.help || summary.note, alignment: "right", iconSize: dynamicStylingHelper('sm', 'xs'), hideButton: !summary.help && !summary.note, ariaLabel: useI18n({
                                id: `stockcars.financing.dynamic.overlay.arialabel.summary.moreinfo.${summary.label}`,
                                defaultMessage: `${summary.label}`,
                            }) }))))))));
};
export const renderRateField = (field, formName, inputFields, i18n, loading) => {
    const value = inputFields[formName] ? inputFields[formName][`$${field.id}`] : undefined;
    const rateField = (React.createElement(ReadonlyInputWrapper, { IsLoading: loading },
        React.createElement(WrapperToOverwriteLegacyCSS, null,
            React.createElement(RateFlexWrapper, null,
                React.createElement(Text, { variant: { type: 'copy', order: dynamicStylingHelper('2', '3'), style: 'normal' }, tag: "p" }, `${field.label}${i18n.financeRateLabelSuffix}`),
                React.createElement(ReadOnlyValue, null,
                    React.createElement(Text, { className: "read-only-value", variant: { type: 'copy', order: dynamicStylingHelper('2', '3'), style: 'bold' }, tag: "p" }, getInputValue(value)))))));
    return rateField;
};
const getInputValue = (val) => {
    if (!val) {
        return '';
    }
    return String(val);
};
const getFormatedInputvalue = (value, field, currency) => {
    const result = field.data.find((item) => item.value === value);
    const formatted = field.data.find((item) => item.text === value);
    if (result && currency && field.displayUnit && field.displayUnit === currency) {
        return (formatted === null || formatted === void 0 ? void 0 : formatted.formattedValue) || `${result.text} ${field.displayUnit}`;
    }
    return result ? `${result.text} ${field.displayUnit}` : formatted === null || formatted === void 0 ? void 0 : formatted.formattedValue;
};
